const PAYBOX_SCRIPT_ID = 'pagoplux-paybox-js'
const PAYBOX_SCRIPT_SRC = 'https://paybox.pagoplux.com/paybox/index_angular.js'

let payboxLoadPromise = null

export function loadPagoPluxPaybox() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve(false)
  }

  if (window.Data && typeof window.Data.init === 'function') {
    return Promise.resolve(true)
  }

  if (payboxLoadPromise) {
    return payboxLoadPromise
  }

  payboxLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(PAYBOX_SCRIPT_ID) || document.querySelector(`script[src="${PAYBOX_SCRIPT_SRC}"]`)
    const script = existingScript || document.createElement('script')

    const finish = () => {
      script.setAttribute('data-loaded', 'true')
      if (window.Data && typeof window.Data.init === 'function') {
        resolve(true)
        return
      }
      payboxLoadPromise = null
      reject(new Error('PagoPlux Paybox loaded without window.Data'))
    }

    const fail = () => {
      payboxLoadPromise = null
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
      reject(new Error('Unable to load PagoPlux Paybox'))
    }

    if (existingScript && script.getAttribute('data-loaded') === 'true') {
      finish()
      return
    }

    script.addEventListener('load', finish, { once: true })
    script.addEventListener('error', fail, { once: true })

    if (!existingScript) {
      script.id = PAYBOX_SCRIPT_ID
      script.src = PAYBOX_SCRIPT_SRC
      script.async = true
      document.head.appendChild(script)
    }
  })

  return payboxLoadPromise
}
